import Col from 'reactstrap/lib/Col';
import Row from 'reactstrap/lib/Row';
import Button from 'reactstrap/lib/Button';

import Card from 'Lib/components/common/Card';

const SubmitOnly = ({ setSubmit }) => {
    return (
        <Card title="Submit">
            <Row>
                <Col style={{ padding: '0' }}>
                    <p>Confirm your application submission</p>
                    <div style={{ float: 'right' }}>
                        <Button color="primary" onClick={() => setSubmit(true)}>
                            Submit Application
                        </Button>
                    </div>
                </Col>
            </Row>
        </Card>
    );
};

export default SubmitOnly;
